import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { BREADCRUMB_ROOT, BREADCRUMB_ROUTES } from '@constants/breadcrumbs';

export interface Crumb {
  path: string;
  labelKey: string;
  isCurrent: boolean;
}

/** Walks `parent` links up from the current route, root first. */
export function buildTrail(pathname: string, search = ''): Crumb[] {
  const trail: Crumb[] = [];
  const seen = new Set<string>();

  let path: string | undefined = BREADCRUMB_ROUTES[pathname] ? pathname : undefined;
  while (path && !seen.has(path)) {
    seen.add(path);
    const route = BREADCRUMB_ROUTES[path];
    if (!route) break;
    trail.unshift({ path, labelKey: route.labelKey, isCurrent: path === pathname });
    path = route.parent;
  }

  if (trail.length === 0) return [];
  if (trail[0].path !== BREADCRUMB_ROOT) {
    trail.unshift({
      path: BREADCRUMB_ROOT,
      labelKey: BREADCRUMB_ROUTES[BREADCRUMB_ROOT].labelKey,
      isCurrent: false,
    });
  }
  const params = new URLSearchParams(search);
  if (pathname === '/drbfm' && params.get('results') === '1' && params.get('edit') !== '1' && params.get('session')) {
    trail[trail.length - 1].isCurrent = false;
    trail.push({ path: `${pathname}${search}`, labelKey: 'drbfm.resultsWorkspace.title', isCurrent: true });
  }
  return trail;
}

export function useBreadcrumbs(): Crumb[] {
  const { pathname, search } = useLocation();
  return useMemo(() => buildTrail(pathname, search), [pathname, search]);
}
